<template>
  <v-card-text style="color: #4F4F4F">
    <v-row class="pa-3">
      Sorry, your email cannot be enabled for HawkSoft E-Signature at this time because you have previously used that email with Formstack Sign.
    </v-row>
    <v-row class="pa-3">
      Please contact us using one of the options below so we can assist you.
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'ExistingEmail'
};
</script>
